/**
 * /channels — bind agents to inbound channels.
 *
 * No loader: role comes from the dashboard-shell auth context.
 */

import { ChannelsBrowser } from "@/features/channels/channels-browser";
import { ChannelsPageHeader } from "@/features/channels/channels-page-header";

import { useAuthState } from "../lib/auth";

export default function ChannelsRoute() {
  const auth = useAuthState();
  const isAdmin = auth.tenant.role === "team_admin";
  return (
    <section className="space-y-4">
      <ChannelsPageHeader />
      <ChannelsBrowser isAdmin={isAdmin} />
    </section>
  );
}
